import { availableSectionViews } from '../../runtime/platform/core.runtime.js';
import { setView } from '../../runtime/shell/navigation.runtime.js';

function openSection(section) {
  const first = availableSectionViews(section)[0]?.[0] || 'schedule';
  void setView(first);
}

export function MobileNav() {
  return (
      <nav class={"mobile-nav"} aria-label={"Мобильная навигация"}>
        <button class={"active"} data-mobile-section={"today"} onClick={() => openSection('today')}>
          <svg viewBox={"0 0 24 24"}>
            <path d={"M7 3v3M17 3v3M4 9h16M5 5h14a1 1 0 0 1 1 1v14H4V6a1 1 0 0 1 1-1Z"}></path>
          </svg>
          <span data-ui-text={"shell.nav.today"}></span>
        </button>
        <button data-mobile-section={"study"} onClick={() => openSection('study')}>
          <svg viewBox={"0 0 24 24"}>
            <path d={"M4 5h16v14H4zM8 9h8M8 13h5"}></path>
          </svg>
          <span data-ui-text={"shell.nav.study"}></span>
        </button>
        <button data-mobile-section={"knowledge"} onClick={() => openSection('knowledge')}>
          <svg viewBox={"0 0 24 24"}>
            <path d={"M4 5.5A3.5 3.5 0 0 1 7.5 2H20v17H7.5A3.5 3.5 0 0 0 4 22V5.5Z"}></path>
          </svg>
          <span data-ui-text={"shell.nav.knowledge"}></span>
        </button>
        <button data-mobile-section={"campus"} onClick={() => openSection('campus')}>
          <svg viewBox={"0 0 24 24"}>
            <path d={"m9 18-6 3V6l6-3 6 3 6-3v15l-6 3-6-3Zm0 0V3m6 18V6"}></path>
          </svg>
          <span data-ui-text={"shell.nav.campus"}></span>
        </button>
        <button data-mobile-section={"more"} onClick={() => openSection('more')}>
          <svg viewBox={"0 0 24 24"}>
            <path d={"M5 12h.01M12 12h.01M19 12h.01"}></path>
          </svg>
          <span data-ui-text={"shell.nav.more"}></span>
        </button>
        <button class={"simple-mobile-item"} data-simple-mobile-view={"home"} onClick={() => void setView('home')}>
          <svg viewBox={"0 0 24 24"}>
            <path d={"M3 11.5 12 4l9 7.5M5.5 10v10h13V10M9 20v-6h6v6"}></path>
          </svg>
          <span data-ui-text={"shell.nav.home"}></span>
        </button>
        <button class={"simple-mobile-item"} data-simple-mobile-view={"schedule"} onClick={() => void setView('schedule')}>
          <svg viewBox={"0 0 24 24"}>
            <path d={"M7 3v3M17 3v3M4 9h16M5 5h14a1 1 0 0 1 1 1v14H4V6a1 1 0 0 1 1-1Z"}></path>
          </svg>
          <span data-ui-text={"shell.nav.schedule"}></span>
        </button>
        <button class={"simple-mobile-item"} data-simple-mobile-view={"studyhub"} onClick={() => void setView('studyhub')}>
          <svg viewBox={"0 0 24 24"}>
            <path d={"M4 5h16v14H4zM8 9h8M8 13h5"}></path>
          </svg>
          <span data-ui-text={"shell.nav.study"}></span>
        </button>
        <button class={"simple-mobile-item"} data-simple-mobile-view={"morehub"} onClick={() => void setView('morehub')}>
          <svg viewBox={"0 0 24 24"}>
            <path d={"M5 12h.01M12 12h.01M19 12h.01"}></path>
          </svg>
          <span data-ui-text={"shell.nav.more"}></span>
        </button>
        <button class={"global-settings-mobile"} id={"mobile-settings-tab"} type={"button"} data-open-settings={""} onClick={() => void setView('settings')}>
          <svg viewBox={"0 0 24 24"}>
            <circle cx={"12"} cy={"12"} r={"3"}></circle>
            <path d={"M19.4 15a1.7 1.7 0 0 0 .3 1.9l.1.1-2.8 2.8-.1-.1a1.7 1.7 0 0 0-1.9-.3 1.7 1.7 0 0 0-1 1.5V21h-4v-.1a1.7 1.7 0 0 0-1-1.5 1.7 1.7 0 0 0-1.9.3l-.1.1L4.2 17l.1-.1a1.7 1.7 0 0 0 .3-1.9 1.7 1.7 0 0 0-1.5-1H3v-4h.1a1.7 1.7 0 0 0 1.5-1 1.7 1.7 0 0 0-.3-1.9L4.2 7 7 4.2l.1.1A1.7 1.7 0 0 0 9 4.6a1.7 1.7 0 0 0 1-1.5V3h4v.1a1.7 1.7 0 0 0 1 1.5 1.7 1.7 0 0 0 1.9-.3l.1-.1L19.8 7l-.1.1a1.7 1.7 0 0 0-.3 1.9 1.7 1.7 0 0 0 1.5 1h.1v4h-.1a1.7 1.7 0 0 0-1.5 1Z"}></path>
          </svg>
          <span data-ui-text={"shell.settings"}></span>
        </button>
      </nav>
  );
}
